const Vignerons_SettingsController_Prix = {
    init: function () {
        if (!($("#content.module-vignerons.controller-settings").length > 0 && $("#Vignerons_Form_Activites_StepPrix").length > 0)) {
            return;
        }
        this.tariffs = JSON.parse($("#tariff").val());
        this.tariffById = {};
        this.$container = $(".tariffs-container");
        this.segmentRange = {
            min: 1,
            max: parseInt($("#segment-max").val())
        };
        if (this.tariffs) {
            for (const tariff of this.tariffs) {
                const identifier = this.uid();
                tariff.identifier = identifier;
                this.tariffById[identifier] = tariff;
            }

            this.draw();
        }

        this.handleSegments();
        this.handleFormSubmit();
        this.handleEditChildTariff();
        this.handleSpecialTariff();
    },

    handleSegments: function () {
        const dialogSegment = document.getElementById("dialogSegment");
        const confirmBtn = document.getElementById('confirmBtn');

        this.$container.on('click', '.js-edit-segment', (e) => {
            const $target = $(e.currentTarget);
            const identifier = $target.closest('.tariff').data('id')
            const tariff = this.tariffById[identifier];
            const segmentIndex = $target.closest('tr').data('index')
            const segment = tariff.segments[segmentIndex];

            const $tariffName = tariff.name && tariff.name.length > 0 ? tariff.name : "Adultes";

            $("#dialog-segment-tariff-name").text($tariffName);
            $(dialogSegment).find('[name="tariff"]').val(identifier);

            $('#segment-slider').noUiSlider({
                start: [segment.min ?? this.segmentRange.min, segment.max ?? this.segmentRange.max],
                range: this.segmentRange
            }, true)

            const showPrice = segment.price / 100;
            const $priceInput = $(dialogSegment).find('[name="price"]');

            $priceInput.val(showPrice.toFixed(Number.isInteger(showPrice) ? 0 : 2));
            $priceInput.attr('autofocus', '');
            $priceInput.select();
        });

        confirmBtn.addEventListener("click", (event) => {
            event.preventDefault();
            const $priceInput = $(dialogSegment).find('[name="price"]');
            const price = Math.round(parseFloat($priceInput.val()) * 100);

            if (isNaN(parseFloat($priceInput.val()))) {
                alert("Le prix renseigné n'est pas correct\"" + $priceInput.val() + "\"");
                return;
            }
            $(dialogSegment).trigger("close");

            const tariffId = $(dialogSegment).find('[name="tariff"]').val();
            const tariff = this.tariffById[tariffId];

            const min = parseInt($(dialogSegment).find("input[name='segment_range_min']").val());
            const max = parseInt($(dialogSegment).find("input[name='segment_range_max']").val());

            const newSegment = {
                price: price,
                min: min,
                max: max === this.segmentRange.max ? null : max
            }

            const addSegment = function (segments, newSegment) {
                // Filtrer les segments en collision
                let collisionSegments = segments.filter(segment => {
                    const segmentMax = segment.max === null ? Infinity : segment.max;
                    const newSegmentMax = newSegment.max === null ? Infinity : newSegment.max;
                    return segment.min <= newSegmentMax && segmentMax >= newSegment.min;
                });

                // Supprimer les segments en collision de la liste originale
                segments = segments.filter(segment => {
                    const segmentMax = segment.max === null ? Infinity : segment.max;
                    const newSegmentMax = newSegment.max === null ? Infinity : newSegment.max;
                    return !(segment.min <= newSegmentMax && segmentMax >= newSegment.min);
                });

                // Ajouter les parties des segments en collision qui ne sont pas couvertes par le nouveau segment
                collisionSegments.forEach(segment => {
                    const segmentMax = segment.max === null ? Infinity : segment.max;
                    const newSegmentMax = newSegment.max === null ? Infinity : newSegment.max;

                    if (segment.min < newSegment.min) {
                        segments.push({min: segment.min, max: newSegment.min - 1, price: segment.price});
                    }
                    if (segmentMax > newSegmentMax) {
                        segments.push({
                            min: newSegmentMax + 1,
                            max: segmentMax === Infinity ? null : segmentMax,
                            price: segment.price
                        });
                    }
                });

                // Ajouter le nouveau segment
                segments.push(newSegment);
                segments.sort((a, b) => a.min - b.min);

                return segments;
            };

            tariff.segments = addSegment(tariff.segments, newSegment);
            this.draw();
        });
    },

    handleEditChildTariff: function () {
        const dialogEditChildTariff = document.getElementById("dialog-tariff-children");

        this.$container.on('click', '.js-edit-child-tariff', (e) => {
            const $target = $(e.currentTarget);
            const identifier = $target.closest('.tariff').data('id')
            const tariff = this.tariffById[identifier];

            $(dialogEditChildTariff).find('[name="tariff"]').val(identifier);
            $("#dialog-tariff-children-tariff-name").text(tariff.name);

            const start = [tariff.ageRange[0], tariff.ageRange[1]];
            const range = {min: 0, max: 17};

            $('#age-slider').noUiSlider({start: start, range: range}, true);
        });

        const dialog = document.getElementById("dialog-tariff-children");
        const confirmBtn = document.getElementById('js-confirm-child-tariff');

        confirmBtn.addEventListener("click", (event) => {
            event.preventDefault();

            const tariffId = $(dialog).find('[name="tariff"]').val();
            const tariff = this.tariffById[tariffId];
            const min = parseInt($("#tariff-children-age-min").val());
            const max = parseInt($("#tariff-children-age-max").val());
            $(dialog).trigger("close");

            const childTariffs = Object.values(this.tariffById).filter(tariff => tariff.type === 'children');
            for (const t of childTariffs) {
                delete this.tariffById[t.identifier];
            }
            this.tariffs = Object.values(this.tariffById);

            const newTariff = {...tariff};
            newTariff.id = null;
            newTariff.identifier = this.uid();
            newTariff.ageRange = [
                min,
                max
            ]
            newTariff.name = newTariff.ageRange[0] === 0
                ? `Enfants < ${newTariff.ageRange[1] + 1}`
                : `Enfants ${newTariff.ageRange[0]} - ${newTariff.ageRange[1]}`;
            const addChildrenTariff = (childTariffs, newTariff) => {
                let collisions = childTariffs.filter(t => t.ageRange[0] <= newTariff.ageRange[1] && t.ageRange[1] >= newTariff.ageRange[0]);
                childTariffs = childTariffs.filter(t => !(t.ageRange[0] <= newTariff.ageRange[1] && t.ageRange[1] >= newTariff.ageRange[0]));
                collisions.forEach(t => {
                    if (t.ageRange[0] < newTariff.ageRange[0]) {
                        const tariff = JSON.parse(JSON.stringify(t));
                        tariff.id = null;
                        tariff.identifier = this.uid();
                        tariff.ageRange = [
                            t.ageRange[0],
                            newTariff.ageRange[0] - 1,
                        ]
                        tariff.name = tariff.ageRange[0] === 0
                            ? `Enfants < ${tariff.ageRange[1] + 1}`
                            : `Enfants ${tariff.ageRange[0]} - ${tariff.ageRange[1]}`;
                        childTariffs.push(tariff);
                    }

                    if (t.ageRange[1] > newTariff.ageRange[1]) {
                        const tariff = JSON.parse(JSON.stringify(t));
                        tariff.id = null;
                        tariff.identifier = this.uid();
                        tariff.ageRange = [
                            newTariff.ageRange[1] + 1,
                            t.ageRange[1],
                        ];
                        tariff.name = tariff.ageRange[0] === 0
                            ? `Enfants < ${tariff.ageRange[1] + 1}`
                            : `Enfants ${tariff.ageRange[0]} - ${tariff.ageRange[1]}`;
                        childTariffs.push(tariff);
                    }
                });
                childTariffs.push(newTariff);
                childTariffs.sort((a, b) => a.ageRange[0] - b.ageRange[0]);

                return childTariffs;
            }

            const newChildrenTariffs = addChildrenTariff(childTariffs, newTariff);
            for (const t of newChildrenTariffs) {
                this.tariffById[t.identifier] = t;
            }
            this.tariffs = Object.values(this.tariffById);
            this.draw();
        });
    },

    handleFormSubmit: function () {
        $("#Vignerons_Form_Activites_StepPrix").submit(function () {
                const tariffs = [];
                for (const tariffIdentifier in Vignerons_SettingsController_Prix.tariffById) {
                    tariffs.push(Vignerons_SettingsController_Prix.tariffById[tariffIdentifier]);
                }
                $("#tariff").val(JSON.stringify(tariffs));
            }
        );
    },

    handleSpecialTariff: function () {
        const dialog = document.getElementById('dialog-create-tariff-special');
        const form = document.getElementById('form-create-tariff-special');
        const errorMessage = document.getElementById('error-message');
        const cancelButton = form.querySelector('button[value="cancel"]');

        cancelButton.addEventListener('click', (event) => {
            event.preventDefault();
            form.reset();
            errorMessage.textContent = '';
            dialog.close('cancel');
        });

        form.addEventListener('submit', (event) => {
            const nameInput = document.getElementById('create-tariff-special-name');

            if (nameInput.value.trim() === '') {
                // Empêche la fermeture de la boîte de dialogue et affiche un message d'erreur
                event.preventDefault();
                errorMessage.textContent = 'Ce champ est obligatoire.';
            } else {
                // Réinitialise le message d'erreur si le champ est valide
                errorMessage.textContent = '';
            }
        });

        dialog.addEventListener('close', () => {
            const action = dialog.returnValue;

            if (action === 'confirm') {
                const formData = new FormData(form);
                const values = Object.fromEntries(formData.entries());
                const newTariff = {
                    id: null,
                    type: 'special',
                    identifier: this.uid(),
                    name: values.name,
                    segments: [
                        {
                            min: 1,
                            max: null,
                            price: 0
                        }
                    ],
                    ageRange: null,
                    visible: false
                };
                this.tariffById[newTariff.identifier] = newTariff;
                this.tariffs = Object.values(this.tariffById);
                this.draw();
                form.reset();
                errorMessage.textContent = '';
            } else if (action === 'cancel') {
                form.reset();
                errorMessage.textContent = '';
            }
        });

        const dialogEdit = document.getElementById("dialog-edit-tariff-special");
        const formEdit = document.getElementById("form-edit-tariff-special");

        this.$container.on('click', '.js-edit-special-tariff', (e) => {
            const $target = $(e.currentTarget);
            const identifier = $target.closest('.tariff').data('id')
            const tariff = this.tariffById[identifier];

            $(dialogEdit).find('[name="tariff"]').val(identifier);
            $("#dialog-edit-tariff-special-title").text(tariff.name);
            $(dialogEdit).find('[name="name"]').val(tariff.name);
        });

        formEdit.addEventListener('submit', (event) => {
            const nameInput = formEdit.querySelector('input[name="name"]');

            if (nameInput.value.trim() === '') {
                // Empêche la fermeture de la boîte de dialogue et affiche un message d'erreur
                event.preventDefault();
                errorMessage.textContent = 'Ce champ est obligatoire.';
            } else {
                // Réinitialise le message d'erreur si le champ est valide
                errorMessage.textContent = '';
            }
        });

        dialogEdit.addEventListener('close', () => {
            const action = dialogEdit.returnValue;
            if (action === 'confirm') {
                const formData = new FormData(formEdit);
                const values = Object.fromEntries(formData.entries())
                const tariff = this.tariffById[values.tariff];
                tariff.name = values.name;
                this.tariffs = Object.values(this.tariffById);
                this.draw();

                form.reset();
                errorMessage.textContent = '';
            } else if (action === 'cancel') {
                form.reset();
                errorMessage.textContent = '';
            }

        });

        this.$container.on('click', '.js-delete-special-tariff', (e) => {
            const $target = $(e.currentTarget);
            const identifier = $target.closest('.tariff').data('id')
            const tariff = this.tariffById[identifier];

            const confirm = window.confirm("Supprimer le tariff spécial " + tariff.name + " ?");
            if (confirm) {
                delete this.tariffById[identifier];
                this.tariffs = Object.values(this.tariffById);
                this.draw();
            }
        });

        this.$container.on('change', '.js-checkbox-visibility', (e) => {
            const $target = $(e.currentTarget);
            const identifier = $target.closest('.tariff').data('id')
            const tariff = this.tariffById[identifier];
            tariff.visible = $target.prop('checked');
            this.draw();
        });
    },

    uid: function () {
        return Date.now().toString(36) + Math.random().toString(36).substring(2);
    },
    escapeHtml: function (text) {
        return text
            .replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")
            .replace(/"/g, "&quot;")
            .replace(/'/g, "&#039;");
    },


    draw: function () {
        this.$container.empty();
        const defaultTariff = Object.values(this.tariffById).filter(tariff => tariff.type === 'default');
        const childrenTariff = Object.values(this.tariffById).filter(tariff => tariff.type === 'children');
        const specialTariffs = Object.values(this.tariffById).filter(tariff => tariff.type === 'special');

        const tariffs = [...defaultTariff, ...specialTariffs, ...childrenTariff];

        for (const tariff of tariffs) {
            const editBtn =
                tariff.type === 'children' ?
                    `<button class="btn-icon js-edit-child-tariff" data-open-dialogV2="#dialog-tariff-children"><span class="icon-pencil-3"></span></button>`
                    : '';

            const visibilityCheckbox =
                `<input type="checkbox" id="checkbox-visibility-${tariff.identifier}" class="js-checkbox-visibility" ${tariff.visible ? `checked` : ''}>
                 <label for="checkbox-visibility-${tariff.identifier}">Rendre visible</label>`;

            const specialToolbar =
                `
                <button type="button" class="btn-icon js-edit-special-tariff" data-open-dialogV2="#dialog-edit-tariff-special">
                    <span class="icon-pencil-3"></span>
                </button>
                <button type="button" class="btn-icon js-delete-special-tariff">
                    <span class="icon-bin-2"></span>
                </button>
                `;
            const isSpecial = tariff.type === 'special';

            const elem = `
                <div class="tariff" data-id="${tariff.identifier}" style="margin-top: 1em;">
                    <div class="subsection-title table-container">
                        <span>${this.escapeHtml(tariff.name && tariff.name.length > 0 ? tariff.name : "Adultes")}${editBtn}  ${isSpecial ? specialToolbar : ''}</span>
                        ${isSpecial ? visibilityCheckbox : ''}
                    </div>
                    <div class="table-container">
                        <table>
                            <thead>
                                <th>Nombre de participants</th>
                                <th>Prix / personne</th>
                            </thead>
                            <tbody></tbody>
                        </table>
                    </div>
                </div>
            `;

            const $elem = $(elem);

            const $tbody = $elem.find("tbody")
            let i = 0;

            for (const segment of tariff.segments) {
                const price = segment.price / 100;

                const segmentName = segment.max !== null
                    ? `De ${segment.min} à ${segment.max ?? this.segmentRange.max}`
                    : `${segment.min} et plus`
                const row = `
                        <tr data-index="${i}">
                            <td>${segmentName}</td>
                            <td>${price.toFixed(Number.isInteger(price) ? 0 : 2)}
                                <button class="btn-action js-edit-segment" data-open-dialogV2="#dialogSegment"><span class="icon-pencil-3"></span></button>
                            </td>
                        </tr>
                `
                $tbody.append(row);
                i++;
            }

            this.$container.append($elem);
        }
    }
}
